import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import LandingPage from './pages/LandingPage'
import TimelinePage from './pages/TimelinePage'
import NetworkPage from './pages/NetworkPage'
import EditorPage from './pages/EditorPage'
import PersonDetailMinimal from './pages/PersonDetailMinimal'
import ItemDetailMinimal from './pages/ItemDetailMinimal'
import ItemDetailPage from './pages/ItemDetailPage'
import TestPage from './pages/TestPage'
import './App.css'
import './i18n'

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/timeline" element={<TimelinePage />} />
        <Route path="/network" element={<NetworkPage />} />
        <Route path="/editor" element={<EditorPage />} />
        <Route path="/person/:personId" element={<PersonDetailMinimal />} />
        <Route path="/item/:itemId" element={<ItemDetailPage />} />
      </Routes>
    </Router>
  )
}

export default App
